import React from 'react';
import { Card, Breadcrumb } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import Page, { PageType } from '@constants/page';
import styles from '@pages/UploadFileListPage/UploadListPage.module.scss';
import BreadcrumbStep from './BreadcrumbStep';

type Props = {
  currentPage: PageType;
};

function NavigationBreadcrumb({ currentPage }: Props) {
  const params = useParams();
  const possibleNavigationSteps = currentPage.breadcrumbPages.map(page => Page[page]);
  const entityIds = [...Object.values(params).reverse(), undefined];

  const stepsToDisplay = [];

  let currentStep = possibleNavigationSteps.pop();
  let currentStepEntityId = entityIds.pop();

  while (currentStep && currentStep.key !== currentPage.key) {
    stepsToDisplay.push(
      <BreadcrumbStep
        key={currentStep.key}
        page={currentStep}
        entityId={currentStepEntityId}
        isCurrentPage={false}
      />
    );
    currentStep = possibleNavigationSteps.pop();
    currentStepEntityId = entityIds.pop();
  }
  if (currentStep) {
    stepsToDisplay.push(
      <BreadcrumbStep
        key={currentStep.key}
        page={currentStep}
        entityId={currentStepEntityId}
        isCurrentPage
      />
    );
  }

  return (
    <Card fluid color="blue" className={styles.breadcrumbContainer}>
      <Breadcrumb>{stepsToDisplay}</Breadcrumb>
    </Card>
  );
}

export default NavigationBreadcrumb;
